module.exports = __webpack_public_path__ + "assets/3b358b238b7d2c1d3530fe1ab78d4559.png";